import { acceptPhoneValue } from '../../field-viewer/shared-normalizers';
export const contactsPhoneViewer = {
    normalizeLoadedValue: acceptPhoneValue
};

//# sourceMappingURL=definition-viewer.js.map